export default __webpack_public_path__ + "assets/f75b1ddd1c0bcde4f3b17009ea2cb75b.png";